<template>
	<div class="father" v-if="show">
		<div class="pop">
			<div class="title">
				<div class="tips">
					<img src="@/assets/face/tips.svg" />
					<span>提示</span>
				</div>
				<div class="closure botcss" @click="show = false" v-if="xIshow">
					×
				</div>
			</div>
			<div class="cont">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			xIshow: {
				type: Boolean,
				defaule: true
			}
		},
		data() {
			return {
				show: false,
			}
		},
		methods: {
			close() {
				this.show = false
				//close
			},
			open() {
				this.show = true
			}
		}
	}
</script>

<style scoped lang="scss">
	.father {
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .3);
		position: fixed;
		z-index: 12;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;

		.pop {
			background-color: #fff;
			border-radius: 10px;
			z-index: 12;
			width: 446px;
			height: 270px;
			position: fixed;
			margin: auto;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;

			.title {
				width: 410px;
				height: 52px;
				border-bottom: 2px solid rgb(213, 213, 213);
				margin: 0 auto;
				display: flex;
				justify-content: space-between;

				.tips {
					width: 40%;
					height: 50px;

					img {
						margin: 20px 0 0 0;
					}

					span {
						margin-left: 7px;
						position: relative;
						top: -4px;
					}
				}

				.closure {
					width: 50px;
					height: 50px;
					text-align: right;
					line-height: 50px;
					font-size: 50px;
				}
			}

			.cont {
				width: 410px;
				margin: 20px auto;
				text-align: center;

				&>div {
					margin: 0 auto;
				}

				img {
					margin: 10px 44% 15px;
				}

				.tit {
					width: 90%;
					height: 30px;
					font-size: 18px;
				}

				.txt {
					width: 90%;
					height: 50px;
				}

				.pop_bot {
					width: 90%;
					height: 40px;
					display: flex;
					justify-content: space-around;

					.bot {
						width: 97px;
						height: 35px;
						line-height: 35px;
						border-radius: 5px;
						color: white;
						margin-top: 20px;
						background-color: #0662B3;
						cursor: pointer;
					}

					.cancel {
						background-color: #CECECE;
					}
				}
			}
		}
	}
</style>
